import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import { setActiveSection } from '@redux/site/siteSlice'
import { Outlet } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import { Tabs } from '@components/Tabs/Tabs'

export const Privacy = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Privacy'))
  })

  return (
    <>
      <Tabs
        data={[
          {
            label: 'Prospective Contacts',
            path: `${RoutePaths.ACCOUNT_SETTINGS}/${RoutePaths.ACCOUNT_SETTINGS_PRIVACY}/${RoutePaths.ACCOUNT_SETTINGS_PRIVACY_PROSPECTIVE_CONTACTS}`,
          },
          {
            label: 'Contacts',
            path: `${RoutePaths.ACCOUNT_SETTINGS}/${RoutePaths.ACCOUNT_SETTINGS_PRIVACY}/${RoutePaths.ACCOUNT_SETTINGS_PRIVACY_CONTACTS}`,
          },
          {
            label: 'Community Partners',
            path: `${RoutePaths.ACCOUNT_SETTINGS}/${RoutePaths.ACCOUNT_SETTINGS_PRIVACY}/${RoutePaths.ACCOUNT_SETTINGS_PRIVACY_COMMUNITY_PARTNERS}`,
          },
        ]}
      />
      <Outlet />
    </>
  )
}
